/* RESPONSIBLE TEAM: team-frontend-tech */
import Route from '@ember/routing/route';

export default class AppsAppVideoRoute extends Route {
  analytics = {
    place: 'video',
    section: 'video',
  };
}
